module.exports = __webpack_public_path__ + "school/img/falvshengming.63d9d14a.jpg";